module.exports = __webpack_public_path__ + "static/media/cloudHome1.548cfb49.png";